export default __webpack_public_path__ + "static/media/home_protfolios_animation.88a6e52d.jpg";